import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'any' })
export class NullLists
{
    public get(count: number): null[] { return Array(count).fill(null); }
}
